import { saveAs } from "file-saver";

/**
 *
 * @param response {object}
 */
const downloadFile = (response) => {
  const name = response["headers"]["content-disposition"].split("filename=")[1];
  const finalName = name.replaceAll('"', "");
  const blob = new Blob([response.data], { type: response["headers"]["content-type"] });
  saveAs(blob, finalName);
};

/**
 * Downloads a file using a GET request by the browser.
 * We typically use this with presigned URLs pointing to files in S3.
 * However, technically you could use it with any publicly accessible file URL.
 *
 * NOTE: The requests generated by this function will NOT include any authentication credentials.
 * This means that the URL provided must be a publicly accessible GET request.
 * Again, this is typically used with presigned URLs from S3.
 *
 * @param {string} fileUrl the URL of the file to be downloaded (GET request)
 */
export const downloadFileWithoutPopup = (fileUrl) => {
  /** Avoids window.open and prevent users asking for support because of browser's pop-ups blockers*/
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = fileUrl;
  link.setAttribute("download", "");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Creates an object URL for the provided blob, triggers the browser to download it via a link
 * click, then revokes the URL.
 *
 * @param {Blob} blob
 * @param {string} filename - File name including extension
 */
const downloadBlob = (blob, filename) => {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.click();

  // Clean up the URL object
  URL.revokeObjectURL(url);
};

/**
 * Creates a CSV (client side) from the provided contents and triggers the browser to download it.
 *
 * @param {string} content - CSV content
 * @param {string} filename - File name without .csv extension
 */
export const downloadCSV = (content, filename) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  downloadBlob(blob, `${filename}.csv`);
};

/**
 * Creates a JSON file (client side) from the provided contents and triggers the browser to download it.
 *
 * @param {object} content - JSON-serializable content
 * @param {string} filename - File name without .json extension
 */
export const downloadJSON = (content, filename) => {
  const blob = new Blob([JSON.stringify(content, null, 2)], { type: "application/json;charset=utf-8;" });
  downloadBlob(blob, `${filename}.json`);
};

export default downloadFile;
